import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DueDateInBatchesComponent } from './components/due-date-in-batches/due-date-in-batches.component';

const routes: Routes = [
    { path: 'due-date-in-batches', component: DueDateInBatchesComponent },
    { path: 'due-date-in-batches:ContextSelected', component: DueDateInBatchesComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class BilletRoutingModule {}
